import { NavItem, CompanyInfo } from '../types';

export const navigationItems: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Showroom', path: '/showroom' },
  { label: 'Contact', path: '/contact' },
];

export const companyInfo: CompanyInfo = {
  name: 'Mims Family Painting',
  tagline: 'Painting & finishes for considered spaces',
  phone: '631-218-5815',
  email: 'mims@mimspainting.com',
  instagram: 'https://www.instagram.com/mimspainting',
  address: 'Long Island & New York City',
};
